import { Field } from '@base-ui/react/field'

const FieldRoot = Field.Root

const FieldLabel = Field.Label

const FieldControl = Field.Control

const FieldDescription = Field.Description

const FieldError = Field.Error

export { FieldRoot, FieldLabel, FieldControl, FieldDescription, FieldError }
